export default "__VITE_ASSET__BHT7xGoR__"